class ChatIndicator extends HTMLElement {
  constructor() {
    super();

    const initGorgiasChatPromise = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise(function (resolve) {
          window.addEventListener("gorgias-widget-loaded", function () {
            resolve();
          });
        });

    initGorgiasChatPromise.then(() => this.enableIndicator());

    this.addEventListener("click", () => {
      initGorgiasChatPromise.then(() => {
        if (GorgiasChat.isOpen()) {
          GorgiasChat.close();
        } else {
          GorgiasChat.open();
        }
      });
    });
  }

  enableIndicator() {
    if (!this.hasAttribute("enable-indicator")) return;

    this.querySelector("button").classList.toggle(
      "chat-indicator__button--active",
      GorgiasChat.isBusinessHours()
    );
  }
}

if (!customElements.get("chat-indicator")) {
  customElements.define("chat-indicator", ChatIndicator);
}
